import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CardPayment } from '../models/mercadopago.model';

@Injectable({
  providedIn: 'root'
})
export class MercadopagoApiService {
  private authHeaders: HttpHeaders;

  constructor(private httpClient: HttpClient) { }

  makePayment(cardPayment: CardPayment, access_token: string, url: string): Observable<any> {
    this._setAuthHeaders(access_token);
    return this.httpClient.post(this.normalizeUrl(url) + '/Payment', cardPayment, { headers: this.authHeaders });
  }

  getMercadoPagoPromotions(url: string): Observable<any> {
    return this.httpClient.get(url);
  }

  normalizeUrl(url: string): string {
    if (url.length > 0 && url.charAt(url.length - 1) == '/') {
      url = url.substr(0, url.length - 1);
    }
    return url;
  }

  private _setAuthHeaders(access_token: string) {
    const userToken = 'Bearer ' + access_token;
    this.authHeaders = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': userToken });
  }
}
